import React from "react";

/**
 * LinkifiedMessage
 * 
 * Converts plain text containing URLs into clickable links. 
 * Supports different link colors depending on whether the message
 * was sent by the current user or received from someone else.
 *
 * @param {Object} props
 * @param {string} props.text - The plain text message to render.
 * @param {boolean} props.isChatByCurrentUser - True if the message was sent by the current user.
 * @returns {React.ReactElement|null} A React element with linkified text or null if no text.
 */
export const LinkifiedMessage = ({ text, isChatByCurrentUser }) => {
    if (!text) return null;

    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);

    const linkColor = isChatByCurrentUser ? "#ffffff" : "#1976d2";

    return (
        <span>
            {parts.map((part, idx) =>
                urlRegex.test(part) ? (
                    <a
                        key={idx}
                        href={part}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: linkColor, textDecoration: "underline" }}
                    >
                        {part}
                    </a>
                ) : (
                    part
                )
            )}
        </span>
    );
};
